import { ReactNode, useEffect } from 'react';
import useGetAccountConfig from '@/hooks/useGetAccountConfig';
import useAuth from '@/hooks/useAuth';

const RequireConfig = ({ children }: { children: ReactNode }) => {
  const [data, status] = useGetAccountConfig();
  const { setUser } = useAuth();

  // Limpiar sesión cuando hay error de autenticación
  // RequireAuth (padre) se encargará de redirigir cuando detecte que no hay accessToken
  useEffect(() => {
    if (status === 'error') {
      setUser({});
    }
  }, [status, setUser]);

  // Mientras carga o hay error, mostrar loading
  // Cuando se limpie el estado, RequireAuth redirigirá automáticamente
  if (!data) {
    return <>Cargando...</>;
  }

  return <>{children}</>;
};

export default RequireConfig;
